"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
const column_numeric_transformer_1 = require("../transformers/column-numeric-transformer");
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
class BaseService {
}
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        name: 'name',
        length: 255,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'description_en__c',
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "descriptionEn", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'description_de__c',
        length: 255,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "descriptionDe", void 0);
__decorate([
    data_ui_1.DataUi.Description('Price for Partner. If the price is not null on the norm service, but you want to overwrite with Null on Opp Level, you need to use the magic number "111107777777"'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)({
        name: 'price_purchasing__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseService.prototype, "pricePurchasing", void 0);
__decorate([
    data_ui_1.DataUi.Description('Price for Brand or Brand_2. If the price is not null on the norm service, but you want to overwrite with Null on Opp Level, you need to use the magic number "111107777777"'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)({
        name: 'price_selling__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseService.prototype, "priceSelling", void 0);
__decorate([
    data_ui_1.DataUi.Description('Price for Customer or Customer_2. If the price is not null on the norm service, but you want to overwrite with Null on Opp Level, you need to use the magic number "111107777777"'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)({
        name: 'price_lists__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseService.prototype, "priceLists", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'tage_bis_zur_finalisierung_sla__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BaseService.prototype, "daysUntillFinalizationSla", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Brand training' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('Weiterbildung', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'weiterbildung__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "additionalEducation", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Zusatzqualifikation' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('Zertifikat_Zusatzqualifikation', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'zusatzqualifikation__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "additionalQualification", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768, emptyToNull: true, isRichText: true }),
    (0, typeorm_1.Column)('text', {
        name: 'hints_de__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "hintsDe", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768, emptyToNull: true, isRichText: true }),
    (0, typeorm_1.Column)('text', {
        name: 'hints_en__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "hintsEn", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'technischer_support__c',
        length: 40,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "technicalSupport", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768, emptyToNull: true }),
    (0, typeorm_1.Column)({
        type: 'text',
        name: 'not_part_of_service__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "notPartOfService", void 0);
__decorate([
    data_ui_1.DataUi.Override({
        label: 'Installationsanleitung (Link)',
        emptyToNull: true,
    }),
    (0, typeorm_1.Column)('character varying', {
        name: 'installationsanleitung__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "installationGuide", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        name: 'map_purchasing_negative__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "mapPurchasingNegative", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        name: 'map_selling_negative__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "mapSellingNegative", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('visible_for', true),
    data_ui_1.DataUi.Override({
        emptyToNull: true,
    }),
    (0, typeorm_1.Column)('character varying', {
        name: 'editable_for__c',
        length: 4099,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseService.prototype, "editableFor", void 0);
exports.BaseService = BaseService;
//# sourceMappingURL=base-service.js.map